(function () {
  // Inject CSS: disable drag, touch-callout, and user-select on media elements
  var s = document.createElement('style');
  s.textContent =
    'img, video, picture, source {' +
    '  -webkit-user-drag: none;' +
    '  -webkit-touch-callout: none;' +
    '  user-select: none;' +
    '  -webkit-user-select: none;' +
    '}' +
    '[style*="background-image"] {' +
    '  -webkit-touch-callout: none;' +
    '}';
  document.head.appendChild(s);

  // Block right-click context menu on images, videos, and background-image elements
  document.addEventListener('contextmenu', function (e) {
    var t = e.target;
    if (!t) return;
    var tag = t.tagName ? t.tagName.toLowerCase() : '';
    if (
      tag === 'img' ||
      tag === 'picture' ||
      tag === 'video' ||
      tag === 'source' ||
      tag === 'svg'
    ) {
      e.preventDefault();
      return false;
    }
    try {
      var bg = window.getComputedStyle(t).backgroundImage;
      if (bg && bg !== 'none' && bg.indexOf('url(') === 0) {
        e.preventDefault();
        return false;
      }
    } catch (_) {}
  }, false);

  // Block image drag (allows save-as via drag in many browsers)
  document.addEventListener('dragstart', function (e) {
    var t = e.target;
    if (t && t.tagName && t.tagName.toLowerCase() === 'img') {
      e.preventDefault();
      return false;
    }
  }, false);
})();
